// Versión de la aplicación — mostrada en el sidebar y el login.
// Al desplegar una actualización, bumpear aquí (y en package.json / client/package.json).
export const APP_VERSION = 'v1.1.0'
export const APP_BRAND = 'YANGO Ingeniería'
export const APP_TAG = `${APP_BRAND} · ${APP_VERSION}`
